import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const c = () => /* @__PURE__ */ s.jsx("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ s.jsx(
  "path",
  {
    d: "m13.336.6 3.734 4.2L13.336 9V5.85H9.603v-2.1h3.733zM6.803 3.75c-.513 0-.933.472-.933 1.05 0 .577.42 1.05.933 1.05s.933-.473.933-1.05-.42-1.05-.933-1.05m-3.733 0c-.514 0-.934.472-.934 1.05 0 .577.42 1.05.934 1.05.513 0 .933-.473.933-1.05s-.42-1.05-.933-1.05m.933 10.5h3.733v-2.1H4.003V9L.27 13.2l3.733 4.2zm6.533 0c.514 0 .934-.473.934-1.05s-.42-1.05-.934-1.05c-.513 0-.933.472-.933 1.05 0 .577.42 1.05.933 1.05m3.734 0c.513 0 .933-.473.933-1.05s-.42-1.05-.933-1.05-.934.472-.934 1.05c0 .577.42 1.05.934 1.05",
    fill: "currentColor"
  }
) });
export {
  c as V
};
